import './select.css';

import { CheckIcon } from '@heroicons/react/24/outline';
import { Item, ItemIndicator, ItemText } from '@radix-ui/react-select';
import React from 'react';

import { cn } from '@/services/utils';

import { Icon } from '../Icon';

/**
 * The component that contains the select items.
 */
const SelectItem = React.forwardRef<
    React.ElementRef<typeof Item>,
    React.ComponentPropsWithoutRef<typeof Item>
>(({ className, children, ...props }, ref) => (
    <Item
        ref={ref}
        className={cn(
            `select-item
                 tw-relative
                 tw-flex
                 tw-w-full
                 tw-cursor-default
                 tw-select-none
                 tw-items-center
                 tw-rounded-sm
                 tw-py-1.5
                 tw-pl-6
                 tw-pr-2
                 tw-text-t-sm
                 tw-outline-none
                 data-[disabled]:tw-pointer-events-none
                 data-[disabled]:tw-opacity-50`,
            className,
        )}
        {...props}
    >
        <span className="tw-absolute tw-top-2 tw-left-1 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center">
            <ItemIndicator className="unset">
                <Icon icon={CheckIcon} size="sm" />
            </ItemIndicator>
        </span>

        <ItemText>{children}</ItemText>
    </Item>
));

SelectItem.displayName = Item.displayName;

export { SelectItem };
